import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-home\"><path d=\"M10.5,3a4.5,4.5,0,0,0-2.27,8.38A7,7,0,0,0,3.5,18a.5.5,0,0,0,1,0,6,6,0,0,1,6-6,4.5,4.5,0,0,0,0-9Zm0,8A3.5,3.5,0,1,1,14,7.5,3.5,3.5,0,0,1,10.5,11Z\" /><rect x=\"12\" y=\"13\" width=\"6\" height=\"1\" rx=\"0.5\" /><rect x=\"12\" y=\"15\" width=\"6\" height=\"1\" rx=\"0.5\" /><rect x=\"12\" y=\"17\" width=\"6\" height=\"1\" rx=\"0.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol